import React from "react";
import { Tooltip as MuiTooltip } from "@mui/material";

/**
 * Drop-in replacement for MUI's Tooltip.
 * Ignores the `placement` prop and always positions
 * bottom-right of the live cursor position.
 */
export default function ToolTip({
    title,
    children,
    disableHoverListener,
    disableTouchListener,
    arrow = true,
    ...rest
}) {
    const [position, setPosition] = React.useState(null);

    const handleMouseMove = (event) => {
        setPosition({ x: event.clientX, y: event.clientY });
    };

    const handleMouseLeave = () => {
        setPosition(null);
    };

    const virtualAnchor = React.useMemo(() => {
        if (!position) return null;
        return {
            getBoundingClientRect: () => ({
                top: position.y,
                left: position.x,
                right: position.x,
                bottom: position.y,
                width: 0,
                height: 0,
                x: position.x,
                y: position.y,
                toJSON: () => {},
            }),
        };
    }, [position]);

    return (
        <MuiTooltip
            title={title}
            placement="bottom-start" 
            disableHoverListener={disableHoverListener}
            disableTouchListener={disableTouchListener}
            open={!!position && !disableHoverListener}
            PopperProps={{
                anchorEl: virtualAnchor,
                modifiers: [{ name: "offset", options: { offset: [8, 8] } }],
            }}
            {...rest}
        >
            <span
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                style={{ display: "inline-block", width: "100%" }}
            >
                {children}
            </span>
        </MuiTooltip>
    );
}